<script>
import rulesMixins from '@/components/Mixins/rulesMixins.vue';
export default {
    mixins: [rulesMixins],
    components: {

    },

    props: {
        value: {},
        readOnly: {
            type: Boolean,
            default: false,
        },
        property: {
            type: Object,
            required: true,
        }
    },

    data (){
        return {
            valueCopy: '',
        };
    },

    computed: {
        rules (){
            return this.rulesList[this.datatype];
        },
        datatype (){
            return this.property.datatype;
        }

    },

    watch: {
        value: {
            handler(val) {
                this.valueCopy = val === undefined ? '' : val;
            },
            immediate: true,
        },
        rules (){
            // mis dans nextTick sinon le validate était appelé avec la rule précèdente.
            // raison => ¯\_(ツ)_/¯
            this.$nextTick(() => {
                this.$emit('validate-form');
            });
        },
    },
    mounted (){
    },

    methods: {
        emitValue (){
            this.$emit('input', this.valueCopy);
        },
        resetDefaultValue (){
            this.valueCopy = '';
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/FieldsTypes/field-mixin.vue